import api from './api';

class VendorService {
  // Get all vendors with pagination and filtering
  static async getVendors(params = {}) {
    try {
      const response = await api.get('/vendors', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching vendors:', error);
      throw this.handleError(error);
    }
  }

  // Get vendor by ID
  static async getVendor(id) {
    try {
      const response = await api.get(`/vendors/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching vendor:', error);
      throw this.handleError(error);
    }
  }

  // Create new vendor
  static async createVendor(vendorData) {
    try {
      const response = await api.post('/vendors', vendorData);
      return response.data;
    } catch (error) {
      console.error('Error creating vendor:', error);
      throw this.handleError(error);
    }
  }

  // Update vendor
  static async updateVendor(id, vendorData) {
    try {
      const response = await api.put(`/vendors/${id}`, vendorData);
      return response.data;
    } catch (error) {
      console.error('Error updating vendor:', error);
      throw this.handleError(error);
    }
  }

  // Delete vendor
  static async deleteVendor(id) {
    try {
      const response = await api.delete(`/vendors/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting vendor:', error);
      throw this.handleError(error);
    }
  }

  // Get vendor statistics
  static async getVendorStats() {
    try {
      const response = await api.get('/vendors/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching vendor stats:', error);
      throw this.handleError(error);
    }
  }

  // Bulk operations
  static async bulkVendorOperations(operation, vendorIds, data = {}) {
    try {
      const response = await api.post('/vendors/bulk', {
        operation,
        vendorIds,
        data
      });
      return response.data;
    } catch (error) {
      console.error('Error performing bulk vendor operations:', error);
      throw this.handleError(error);
    }
  }

  // Export vendors
  static async exportVendors(format = 'csv') {
    try {
      const response = await api.get('/vendors/export', {
        params: { format },
        responseType: format === 'csv' ? 'blob' : 'json'
      });
      return response.data;
    } catch (error) {
      console.error('Error exporting vendors:', error);
      throw this.handleError(error);
    }
  }

  // Handle API errors
  static handleError(error) {
    if (error.response) {
      // Server responded with error status
      return {
        message: error.response.data?.message || 'An error occurred',
        status: error.response.status,
        data: error.response.data
      };
    } else if (error.request) {
      // Request was made but no response received
      return {
        message: 'Network error - please check your connection',
        status: 0
      };
    } else {
      // Something else happened
      return {
        message: error.message || 'An unexpected error occurred',
        status: 0
      };
    }
  }
}

export default VendorService;
